/* Florema · Colección editorial (sección florema-coleccion-editorial) · oct 2026
   Todo trabaja dentro de [data-flc-root]: aparición al bajar, pestañas que se arrastran, panel de filtros (del lado
   del navegador, sobre las tarjetas que hay en la página), orden (?sort_by=), "Ver más productos" (trae la página
   siguiente) y apagado de los textos Cyber al terminar. Agregar al carro lo hace florema-card.js (compartido con todas las tarjetas). */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__flc) return;
    root.__flc = true;
    root.classList.add('flc-js');

    var doc = document, html = doc.documentElement;
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hasIO = 'IntersectionObserver' in window;
    var $ = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    var familyMode = root.getAttribute('data-mode') === 'familia';
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;

    var grid = $('[data-flc-grid]');
    var barEl = $('[data-flc-bar]');
    var drawer = $('[data-flc-drawer]');
    var groupsEl = $('[data-flc-groups]');
    var chipsEl = $('[data-flc-chips]');
    var resEl = $('[data-flc-res]');
    var nEl = $('[data-flc-n]');
    var emptyEl = $('[data-flc-empty]');
    var verBtn = $('[data-flc-ver]');
    var limBtn = drawer && $('.flc-lim', drawer);
    var openBtn = $('[data-flc-open]');
    var sortBtn = $('[data-flc-sort-btn]');
    var tabsEl = $('[data-flc-tabs]');
    var moreWrap = $('[data-flc-morewrap]');

    var cards = function () { return $$('.flk-card', grid); };

    /* ---------- 1. Cyber: apagado de los textos "CYBER" al terminar ---------- */
    function parseEnd(s) {
      s = String(s || '').replace(/^\s+|\s+$/g, '');
      if (!s) return NaN;
      // "2026-10-11 23:59" (hora de Chile, UTC−3) → "2026-10-11T23:59:00-03:00"
      var m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?\s*(Z|[+-]\d{2}:?\d{2})?$/);
      if (!m) return Date.parse(s);
      var hh = m[2].length === 1 ? '0' + m[2] : m[2];
      var tz = m[5] ? (m[5] === 'Z' ? 'Z' : m[5].replace(/^([+-]\d{2})(\d{2})$/, '$1:$2')) : '-03:00';
      return Date.parse(m[1] + 'T' + hh + ':' + m[3] + ':' + (m[4] || '00') + tz);
    }
    function termina() { root.classList.add('flc-fin'); }
    if (root.classList.contains('flc--cy')) {
      var END = parseEnd(root.getAttribute('data-end'));
      if (!(END > 0)) { var cb = doc.querySelector('[data-florema-cyber-bar][data-end]'); if (cb) END = parseEnd(cb.getAttribute('data-end')); }
      if (/[?&]fin=1(&|$)/.test(location.search) || (END > 0 && END <= Date.now())) termina();
      else if (END > 0 && END - Date.now() < 2147000000) setTimeout(termina, END - Date.now() + 500);
    }

    /* ---------- 2. barra fija: se pega justo bajo el encabezado compacto del tema ---------- */
    var hdr = doc.querySelector('.florema-hdr');
    var syncTop = function () {
      if (!hdr || !html.classList.contains('fl-compacto')) return;
      var b = Math.round(hdr.getBoundingClientRect().bottom);
      if (b > 20 && b < 200) root.style.setProperty('--flc-top', b + 'px');
    };
    if (hdr) {
      hdr.addEventListener('transitionend', syncTop);
      window.addEventListener('resize', function () { setTimeout(syncTop, 60); }, { passive: true });
      if (window.MutationObserver) new MutationObserver(function () { syncTop(); setTimeout(syncTop, 380); }).observe(html, { attributes: true, attributeFilter: ['class'] });
      setTimeout(syncTop, 120);
    }
    function toGrid(force) {
      var anchor = tabsEl || grid, top = parseInt(getComputedStyle(root).getPropertyValue('--flc-top'), 10) || 62;
      var y = anchor.getBoundingClientRect().top + window.scrollY - top - 14;
      if (force || window.scrollY > y) window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    }

    /* ---------- 3. aparición suave al entrar en pantalla (solo con JS: sin JS todo queda visible) ---------- */
    var io = (hasIO && !reduce) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 }) : null;
    var colCount = function () { return getComputedStyle(grid).gridTemplateColumns.split(' ').length || 1; };
    function reveal(list) {
      var cols = colCount(), n = 0;
      list.forEach(function (el) {
        if (!io) { el.classList.add('in'); return; }
        if (el.classList.contains('flk-card')) el.style.transitionDelay = ((n % cols) * 70) + 'ms';
        n++; io.observe(el);
      });
    }
    reveal($$('.flk-card, .flc-pausa, .flc-tile', grid));

    /* ---------- 3b. en vista previa (?view=editorial) las pestañas conservan el parámetro ---------- */
    (function () {
      var v = new URLSearchParams(location.search).get('view'); if (!v) return;
      $$('.flc-tab').forEach(function (a) {
        try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('view', v); a.setAttribute('href', u.pathname + u.search); } catch (e) {}
      });
    })();

    /* ---------- 3c. franja de confianza (celular): el marquee se pausa fuera de pantalla ---------- */
    $$('.flc-franja').forEach(function (f) {
      if (hasIO) new IntersectionObserver(function (es) { f.classList.toggle('is-paused', !es[0].isIntersecting); }).observe(f);
    });

    /* ---------- 4. pestañas: la activa a la vista; filas que se arrastran con el mouse ---------- */
    if (tabsEl) {
      var on = $('[aria-current="page"]', tabsEl);
      if (on && tabsEl.scrollWidth > tabsEl.clientWidth + 4) tabsEl.scrollLeft = Math.max(0, on.offsetLeft - 24);
    }
    (function () {
      var desliza = function (el) {
        while (el && el !== root && root.contains(el)) {
          if (el.nodeType === 1 && el.hasAttribute('data-flc-drag')) {
            var cs = getComputedStyle(el);
            if (/(auto|scroll)/.test(cs.overflowX) && el.scrollWidth > el.clientWidth + 4) return el;
          }
          el = el.parentElement;
        }
        return null;
      };
      var fila = null, x0 = 0, s0 = 0, ultX = 0, ultT = 0, vel = 0, movio = false, snap = '';
      root.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        fila = desliza(e.target); if (!fila) return;
        x0 = ultX = e.clientX; s0 = fila.scrollLeft; ultT = performance.now(); vel = 0; movio = false;
        snap = fila.style.scrollSnapType; fila.style.scrollSnapType = 'none'; fila.style.scrollBehavior = 'auto';
      });
      window.addEventListener('pointermove', function (e) {
        if (!fila) return;
        var dx = e.clientX - x0;
        // la clase de "arrastrando" entra solo cuando de verdad hubo movimiento: un clic simple sigue llegando al enlace
        if (!movio && Math.abs(dx) > 5) { movio = true; fila.classList.add('flc-drag'); }
        if (!movio) return;
        fila.scrollLeft = s0 - dx;
        var t = performance.now(); vel = (e.clientX - ultX) / Math.max(1, t - ultT); ultX = e.clientX; ultT = t;
        e.preventDefault();
      }, { passive: false });
      var soltar = function () {
        if (!fila) return;
        var f = fila, v = reduce ? 0 : Math.max(-80, Math.min(80, -vel * 16)); fila = null;
        f.classList.remove('flc-drag');
        var paso = function () {
          if (!(Math.abs(v) >= 0.5)) { f.style.scrollSnapType = snap; f.style.scrollBehavior = ''; return; }
          f.scrollLeft += v; v *= 0.92; raf(paso);
        };
        raf(paso);
        if (movio) {
          var anula = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          doc.addEventListener('click', anula, true);
          setTimeout(function () { doc.removeEventListener('click', anula, true); }, 0);
        }
      };
      window.addEventListener('pointerup', soltar);
      window.addEventListener('pointercancel', soltar);
      root.addEventListener('dragstart', function (e) { if (desliza(e.target)) e.preventDefault(); });
      var marca = function () {
        $$('[data-flc-drag]').forEach(function (el) {
          var cs = getComputedStyle(el);
          el.style.cursor = (/(auto|scroll)/.test(cs.overflowX) && el.scrollWidth > el.clientWidth + 4) ? 'grab' : '';
        });
      };
      marca();
      window.addEventListener('load', marca);
      window.addEventListener('resize', marca, { passive: true });
    })();

    /* ---------- 5. filtros del panel (sobre las tarjetas cargadas) ---------- */
    var S = { fam: [], ar: [], fmt: [], pr: [], st: [] };
    var GROUPS = [
      { k: 'fam', l: 'Familia', skip: familyMode },
      { k: 'ar', l: 'Aroma', hideZero: true },
      { k: 'fmt', l: 'Formato y tamaño', hideZero: familyMode },
      { k: 'pr', l: 'Precio' },
      { k: 'st', l: 'Disponibilidad' }
    ];
    var FAM_ORDER = ['Floral', 'Dulce', 'Cítrica', 'Frutal', 'Amaderada'];
    var FMT_ORDER = ['Packs', 'Difusor 100 ml', 'Difusor 150 ml', 'Home Spray 130 ml', 'Home Spray 250 ml', 'Esencia 10 ml', 'Difusor de auto 8 ml', 'Refill Difusor 350 ml', 'Refill Home Spray 500 ml', 'Humidificadores', 'Bolsa de regalo', 'Otros'];
    var BANDS = ['Hasta $5.000', '$5.000 a $10.000', '$10.000 a $20.000', 'Más de $20.000'];
    var band = function (p) { p = +p; return p <= 5000 ? BANDS[0] : p <= 10000 ? BANDS[1] : p <= 20000 ? BANDS[2] : BANDS[3]; };
    var ICO_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg>';
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

    function val(c, k) {
      if (k === 'pr') return band(c.getAttribute('data-price'));
      if (k === 'st') return c.getAttribute('data-stock') === '1' ? 'Con stock' : '';
      return c.getAttribute('data-' + k) || '';
    }
    function pass(c, skip) {
      for (var i = 0; i < GROUPS.length; i++) {
        var k = GROUPS[i].k;
        if (k === skip || !S[k].length) continue;
        if (S[k].indexOf(val(c, k)) < 0) return false;
      }
      return true;
    }
    var nFiltros = function () { var n = 0; for (var k in S) n += S[k].length; return n; };
    function values(k, all) {
      var seen = [];
      all.forEach(function (c) { var v = val(c, k); if (v && seen.indexOf(v) < 0) seen.push(v); });
      var ord = k === 'fam' ? FAM_ORDER : k === 'fmt' ? FMT_ORDER : k === 'pr' ? BANDS : null;
      if (ord) seen.sort(function (a, b) { var x = ord.indexOf(a), y = ord.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); });
      else if (k === 'ar') {
        // por familia (Floral, Dulce, Cítrica, Frutal) y, dentro, en el orden de aparición
        seen.sort(function (a, b) {
          var ca = all.filter(function (c) { return val(c, 'ar') === a; })[0], cb = all.filter(function (c) { return val(c, 'ar') === b; })[0];
          var x = FAM_ORDER.indexOf(val(ca, 'fam')), y = FAM_ORDER.indexOf(val(cb, 'fam'));
          return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
        });
      }
      return seen;
    }
    function count(k, v, all) {
      var n = 0;
      all.forEach(function (c) { if (val(c, k) === v && pass(c, k)) n++; });
      return n;
    }
    function opt(k, v, all, hideZero) {
      var n = count(k, v, all), sel = S[k].indexOf(v) >= 0;
      if (hideZero && !n && !sel) return '';
      return '<button type="button" class="flc-opt" data-k="' + k + '" data-v="' + esc(v) + '" aria-pressed="' + sel + '"' + (!n && !sel ? ' disabled' : '') + '>' + esc(v) + ' <i>' + n + '</i></button>';
    }
    function renderDrawer(res) {
      var all = cards(), html = '';
      GROUPS.forEach(function (g) {
        if (g.skip) return;
        var vals = values(g.k, all);
        if (g.k === 'st') { if (all.every(function (c) { return c.getAttribute('data-stock') === '1'; })) return; vals = ['Con stock']; }
        else if (vals.length < 2 && !S[g.k].length) return;
        var o = vals.map(function (v) { return opt(g.k, v, all, g.hideZero); }).join('');
        if (o) html += '<fieldset><legend>' + g.l + '</legend><div class="flc-opts">' + o + '</div></fieldset>';
      });
      var top = groupsEl.scrollTop;
      groupsEl.innerHTML = html || '&nbsp;'; groupsEl.scrollTop = top;
      if (verBtn) verBtn.textContent = loading ? 'Cargando productos…' : 'Ver ' + res + (res === 1 ? ' producto' : ' productos');
      if (limBtn) limBtn.disabled = !nFiltros();
    }
    function renderChips() {
      var items = [];
      GROUPS.forEach(function (g) { S[g.k].forEach(function (v) { items.push([g.k, v]); }); });
      chipsEl.hidden = !items.length;
      chipsEl.innerHTML = items.map(function (it) {
        return '<button type="button" class="flc-fchip" data-k="' + it[0] + '" data-v="' + esc(it[1]) + '" aria-label="Quitar filtro ' + esc(it[1]) + '">' + esc(it[1]) + ICO_X + '</button>';
      }).join('') + (items.length ? '<button type="button" class="flc-fchip flc-clr" data-flc-clear>Limpiar</button>' : '');
      var n = nFiltros();
      if (nEl) { nEl.hidden = !n; nEl.textContent = n; }
    }
    function update() {
      var all = cards(), n = 0, filtered = nFiltros() > 0;
      all.forEach(function (c) {
        var off = !pass(c), was = c.classList.contains('flc-off');
        c.classList.toggle('flc-off', off);
        if (!off) { n++; if (was) c.classList.add('in'); }   // al volver a mostrarse no esperan a la aparición suave
      });
      $$('.flc-pausa, .flc-tile, .flc-franja', grid).forEach(function (m) { m.hidden = filtered; });
      if (emptyEl) emptyEl.hidden = !(filtered && n === 0);
      if (moreWrap) moreWrap.hidden = filtered || !nextUrl;
      var shown = filtered ? n : total;
      if (resEl) resEl.innerHTML = '<b>' + shown + '</b> ' + (shown === 1 ? 'resultado' : 'resultados');
      renderChips(); renderDrawer(n);
    }
    var limpiar = function () { S = { fam: [], ar: [], fmt: [], pr: [], st: [] }; };

    /* ---------- 6. "Ver más productos": trae la página siguiente y la suma a la grilla ---------- */
    var moreBtn = $('[data-flc-more]'), nextUrl = moreBtn ? moreBtn.getAttribute('href') : '', loading = false, pend = null;
    function conParams(href) {
      // conserva ?sort_by, ?view y filtros del navegador (la página siguiente no siempre los trae)
      try {
        var u = new URL(href, location.origin), cur = new URLSearchParams(location.search);
        cur.forEach(function (v, k) { if (k !== 'page' && !u.searchParams.has(k)) u.searchParams.set(k, v); });
        return u.toString();
      } catch (e) { return href; }
    }
    function shownTxt() {
      var el = $('[data-flc-shown]'); if (el) el.textContent = 'Mostrando ' + cards().length + ' de ' + total;
    }
    function loadMore() {
      if (!nextUrl) return Promise.resolve(false);
      if (pend) return pend;
      loading = true;
      if (moreBtn) { moreBtn.classList.add('is-loading'); moreBtn.textContent = 'Cargando…'; }
      if (verBtn && drawer && root.classList.contains('flc-drawer-open')) renderDrawer(cards().filter(function (c) { return !c.classList.contains('flc-off'); }).length);
      pend = fetch(conParams(nextUrl), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
        .then(function (t) {
          var d = new DOMParser().parseFromString(t, 'text/html');
          var g = d.querySelector('[data-flc-grid]');
          var els = g ? Array.prototype.slice.call(g.querySelectorAll('.flk-card')) : [];
          if (!els.length) throw new Error('vacía');
          var added = els.map(function (el) {
            var n = doc.importNode(el, true);
            n.classList.remove('in'); n.classList.remove('flc-off'); n.style.transitionDelay = '';
            grid.insertBefore(n, emptyEl || null);
            return n;
          });
          var nb = d.querySelector('[data-flc-more]');
          nextUrl = nb ? nb.getAttribute('href') : '';
          if (nextUrl) { moreBtn.classList.remove('is-loading'); moreBtn.textContent = 'Ver más productos'; moreBtn.setAttribute('href', nextUrl); }
          else if (moreWrap) { moreWrap.innerHTML = ''; moreWrap.hidden = true; moreBtn = null; }
          shownTxt();
          // las nuevas respetan los filtros que ya estén puestos
          if (nFiltros()) update(); else reveal(added);
          return true;
        })
        .catch(function () {
          // si algo falla, el botón vuelve a ser un enlace normal a la página siguiente
          var u = nextUrl; nextUrl = '';
          if (moreBtn) { moreBtn.classList.remove('is-loading'); moreBtn.textContent = 'Ver más productos'; }
          if (u && !pend.__auto) location.href = conParams(u);
          return false;
        })
        .then(function (ok) { loading = false; pend = null; return ok; });
      return pend;
    }
    function loadAll() {
      if (!nextUrl) return Promise.resolve();
      var p = loadMore();
      if (pend) pend.__auto = true;
      return p.then(function (ok) { return ok ? loadAll() : null; });
    }
    if (moreBtn) moreBtn.addEventListener('click', function (e) { e.preventDefault(); loadMore(); });

    /* ---------- 7. paneles: filtros (lateral / hoja inferior) y orden ---------- */
    var lastFocus = null;
    function setDrawer(v) {
      root.classList.toggle('flc-drawer-open', v);
      html.classList.toggle('flc-lock', v);
      if (v) {
        root.classList.remove('flc-sort-open'); if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
        lastFocus = doc.activeElement;
        var x = $('[data-flc-close]', drawer); setTimeout(function () { if (x) x.focus({ preventScroll: true }); }, 60);
        // el panel cuenta con TODAS las páginas de la colección: se traen las que falten
        update(); loadAll().then(function () { update(); });
      } else if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }
    var mobile = function () { return window.matchMedia && window.matchMedia('(max-width:899px)').matches; };
    function setSort(v) {
      root.classList.toggle('flc-sort-open', v);
      if (sortBtn) sortBtn.setAttribute('aria-expanded', String(v));
      if (mobile()) html.classList.toggle('flc-lock', v);
    }
    var toggle = function (arr, v) { var i = arr.indexOf(v); if (i >= 0) arr.splice(i, 1); else arr.push(v); };

    /* ---------- 8. clics ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('.flc-opt'))) { toggle(S[b.getAttribute('data-k')], b.getAttribute('data-v')); update(); return; }
      if ((b = t.closest('.flc-fchip[data-k]'))) { toggle(S[b.getAttribute('data-k')], b.getAttribute('data-v')); update(); return; }
      if (t.closest('[data-flc-clear]')) { limpiar(); update(); return; }
      if (t.closest('[data-flc-open]')) { setDrawer(true); return; }
      if (t.closest('[data-flc-close]')) { setDrawer(false); return; }
      if (t.closest('[data-flc-ver]')) { setDrawer(false); toGrid(false); return; }
      if (t.closest('[data-flc-scrim]')) { setDrawer(false); setSort(false); html.classList.remove('flc-lock'); return; }
      if (t.closest('[data-flc-sort-btn]')) { setSort(!root.classList.contains('flc-sort-open')); return; }
      if ((b = t.closest('[data-flc-sort]'))) {
        // conserva ?view y demás parámetros de la dirección; cambia solo el orden y vuelve a la primera página
        e.preventDefault();
        try { var u = new URL(location.href); u.searchParams.set('sort_by', b.getAttribute('data-flc-sort')); u.searchParams.delete('page'); u.hash = ''; location.href = u.toString(); }
        catch (err) { location.href = b.getAttribute('href'); }
        return;
      }
      if (t.closest('[data-flc-top]')) { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
      if (root.classList.contains('flc-sort-open') && !t.closest('.flc-sortwrap')) setSort(false);
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (root.classList.contains('flc-drawer-open')) setDrawer(false);
      if (root.classList.contains('flc-sort-open')) { setSort(false); html.classList.remove('flc-lock'); }
    });

    /* ---------- 9. el botón de WhatsApp del tema se aparta si taparía un "+" de producto ---------- */
    var waTick = false;
    var waCheck = function () {
      waTick = false;
      var w = doc.querySelector('.florema-wa'); if (!w) return;
      var r = w.getBoundingClientRect(), hit = false;
      $$('.flk-add, .flk-soldout').forEach(function (v) {
        var b = v.getBoundingClientRect();
        if (b.bottom > 0 && b.top < innerHeight && !(b.right < r.left - 8 || b.left > r.right + 8 || b.bottom < r.top - 8 || b.top > r.bottom + 8)) hit = true;
      });
      w.style.opacity = hit ? '0' : '';
      w.style.pointerEvents = hit ? 'none' : '';
    };
    window.addEventListener('scroll', function () { if (!waTick) { waTick = true; raf(waCheck); } }, { passive: true });
    window.addEventListener('resize', function () { if (!waTick) { waTick = true; raf(waCheck); } }, { passive: true });
    waCheck();

    /* ---------- 10. columnas nuevas al girar o cambiar de tamaño: nada que rehacer (la grilla es CSS) ---------- */
    update();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-flc-root]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // editor de temas: al recargar la sección se vuelve a iniciar
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-flc-root]');
    if (r) init(r);
  });
})();
